import { render, staticRenderFns } from "./ui-lazyimage.vue?vue&type=template&id=3ff61828&scoped=true&"
import script from "./ui-lazyimage.vue?vue&type=script&lang=js&"
export * from "./ui-lazyimage.vue?vue&type=script&lang=js&"
import style0 from "./ui-lazyimage.vue?vue&type=style&index=0&id=3ff61828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff61828",
  null
  
)

export default component.exports